import { render, staticRenderFns } from "./Quartercard_area.vue?vue&type=template&id=58f52cbe&scoped=true&"
import script from "./Quartercard_area.vue?vue&type=script&lang=js&"
export * from "./Quartercard_area.vue?vue&type=script&lang=js&"
import style0 from "./Quartercard_area.vue?vue&type=style&index=0&id=58f52cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f52cbe",
  null
  
)

export default component.exports